"use strict";

angular
	.module('rmDashboard')
	.controller('DashboardCtrl', require('./dashboard_ctrl'))
;

